import {observer} from "mobx-react";
import {Component} from "preact";
import logo from "../img/logo.svg";
import {occupancyModel} from "../model";
import {resources} from "../resources";
import {Icon} from "./controls/Icon";
import style from "./NavBar.module.css";

export const NavBar = observer(
	class NavBar extends Component<{ onMyLockers: () => void }> {
		render() {
			const {onMyLockers} = this.props;
			const showLockers = occupancyModel.occupancies.length > 0;
			return (
				<div class={style.navBar}>
					{showLockers && (
						<button class={style.myLockers} onClick={onMyLockers}>
							<Icon>list</Icon>
							<div class={style.lockerText}>{resources.strings.MyLockers}</div>
							<div class={style.lockerCount}>{occupancyModel.occupancies.length}</div>
						</button>
					)}
					<img class={style.logo} alt="VarioCube" src={logo} />
				</div>
			);
		}
	},
);
